module.exports = __webpack_public_path__ + "img/wegame.3222b4ba.png";